import React from 'react';
import { Grid, Box } from '@mui/material';
import StatCard from './StatCard';
import { FileText, AlertTriangle, CheckCircle, Clock } from "lucide-react";

const PRListStats = ({ stats = {}, loading = false }) => {
  const {
    totalPRs = 0,
    criticalIssues = 0,
    avgFixRate = 0,
    underReview = 0
  } = stats;

  const statCards = [
    {
      title: 'Total PRs',
      value: totalPRs,
      icon: <FileText />,
      color: '#00bfff',
      bgcolor: '#00bfff1a'
    },
    {
      title: 'Critical Issues',
      value: criticalIssues,
      icon: <AlertTriangle />,
      color: '#ef4343',
      bgcolor: '#ef43431a'
    },
    {
      title: 'Avg Fix Rate',
      value: `${avgFixRate}%`,
      icon: <CheckCircle />,
      color: '#1f1f1f',
      bgcolor: '#ffffff'
    },
    {
      title: 'Under Review',
      value: `${underReview}`,
      icon: <Clock />,
      color: '#ff8052',
      bgcolor: '#ff80521a'
    }
  ];

  return (
    <Box sx={{ mb: 4 }}>
      <Grid container spacing={3}>
        {statCards.map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.title}>
            <StatCard
              title={card.title}
              value={card.value}
              icon={card.icon}
              color={card.color}
              bgcolor={card.bgcolor}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PRListStats;